import React, { useEffect } from 'react';
import { Button, Card, Popover } from 'antd';
import { Icon } from 'xadmin-ui'
import _ from 'lodash'
import NoData from '../../components/NoData'

const apimonitor = {
  name: 'apimonitor',
  resource: 'core/apimonitor',
  type: 'object',
  icon: <Icon svg={require('../../icon/Log.svg')} />,
  title: '接口调用日志',
  properties: {
    user: {
      title: '用户名称',
      type: 'object',
      properties: {}
    },
    remoteAddr: {
      type: 'string',
      title: 'IP'
    },
    time: {
      type: 'string',
      title: '调用时间',
      format: 'date-time'
    },
    method: {
      type: 'string',
      title: '请求方式',
      enum: ['GET', 'POST', 'PUT', 'DELETE']
    },
    url: {
      type: 'string',
      title: '请求路径'
    },
    params: {
      type: 'string',
      title: '请求参数',
    }
  },
  initialValues: {
    wheres: {
      filter: {
        isThirdCall: true
      }
    }
  },
  itemActions: [],
  filters: {
    submenu: [ 'time', 'method', 'url', 'remoteAddr' ],
  },
  components: {
    DataEmpty: props => <Card><NoData /></Card>
  },
  forceGetItem: true,
  permission: {
    view: true,
    add: false,
    edit: false,
    delete: false
  },
  orders: { time: 'DESC' },
  listFields: [ 'user', 'remoteAddr', 'time', 'method', 'url', 'params' ],
  fieldRender: {
    params: ({ value, wrap: WrapComponent }) => {
      const content = <pre id="myPre" style={{ width: 350, maxHeight: 400, overflowY: "scroll" }}>
        {value ? JSON.stringify(JSON.parse(value), null, '\t') : '空'}
      </pre>
      return <WrapComponent>
        <Popover placement="leftTop" content={content} trigger="click">
          <Button size='small' type='primary'>查看参数</Button>
        </Popover>
      </WrapComponent>
    }
  },
  batchActions: null
}

export default apimonitor
